module.exports = __webpack_public_path__ + "static/media/sp_about_card.fdf8bfe5.jpg";